import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'articles',
        loadChildren: () => import('./modules/articles/articles.module').then(m => m.ArticlesModule)
      },
      {
        path: 'resellers',
        loadChildren: () => import('./modules/resellers/resellers.module').then(m => m.ResellersModule)
      },
      {
        path: 'services',
        loadChildren: () => import('./modules/services/services.module').then(m => m.ServicesModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./modules/customers/customers.module').then(m => m.CustomersModule)
      },
      {
        path: 'technicians',
        loadChildren: () => import('./modules/technicians/technicians.module').then(m => m.TechniciansModule)
      },
      {
        path: 'claims',
        loadChildren: () => import('./modules/claims/claims.module').then(m => m.ClaimsModule)
      },
      {
        path: 'invoices',
        loadChildren: () => import('./modules/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      {
        path: 'devis',
        loadChildren: () => import('./modules/devis/devis.module').then(m => m.DevisModule)
      },
      {
        path: 'purchase-invoice',
        loadChildren: () => import('./modules/purchase-invoice/purchase-invoice.module').then(m => m.PurchaseInvoiceModule)
      },
      {
        path: 'suppliers',
        loadChildren: () => import('./modules/suppliers/suppliers.module').then(m => m.SuppliersModule)
      },
      {
        path: '',
        redirectTo: 'articles',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
